/**
 * The list of editor commands.
 */
const keywordList = {

	'randseed': [ 'randseed', 1 ],
	'randomseed': [ 'randseed', 1 ],

	'randomize': [ 'randomize' ],
	'randomise': [ 'randomize' ],
	'sausage': [ 'randomize' ],

	'var': [ 'setVar', 2 ],
	// 'difference': [ 'difference', 2 ],
	// 'sum': [ 'sum', 2 ],

};


/**
 * Built in keywords.
 */
const keywords = {


	/**
	 * Change the random seed.
	 *
	 * @param {int} arg The new seed value.
	 * @return {void}
	 */
	randseed: function( arg ) {

		arg = Number( arg );
		arg = Math.abs( arg );
		arg = Math.min( 99999, arg );

		random.seed = arg;

	},


	/**
	 * Change random seed.
	 *
	 * @return {void}
	 */
	randomize: function() {

		random.random_seed();

	},


	/**
	 * Set a variable.
	 *
	 * @param {string} key The variable name.
	 * @param {string} value The variable value.
	 * @return {void}
	 */
	setVar: function( args ) {

		// console.log( 'setVar', args );
		app.parser.setVariable( args );

	},


	// sum: function( value1, value2 ) {

	// },


	// difference: function( value1, value2 ) {

	// },

}